export enum HistoryFilter {
  Completed = "completed",
  Anomaly = "anomaly",
  All = "all",
}
